export default "__VITE_ASSET__20dEuvoK__"